import React from "react";
import ReactDOM from "react-dom";
import 'react-toastify/dist/ReactToastify.css';
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import "./styles/_index.scss";

ReactDOM.render(<App />, document.getElementById("root"));
reportWebVitals();
